module.exports = __webpack_public_path__ + "static/media/trabaja-connosotros-imagen.047b4480.webp";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/santajuana/trabaja-connosotros-imagen.webp
// module id = 1686
// module chunks = 0